import { UPDATE_COMPARISON_SIMULATIONS } from "../../data/queries";
import { ComparisonIconButton } from "../comparison/components/ComparisonButton";
import LyfeTooltip from "../../../components/LyfeTooltip";
import { DeleteSimulationDialog } from "./DeleteSimulationDialog";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { GetSimulationsQuery } from "../../data/types/queries.generated";
import { ProductBlueprintStatus, SimulatorUserRole } from "../../../models/generated/graphql";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Box, IconButton } from "@material-ui/core";
import { useModelsMutation } from "../../../hooks/useModelsModule";

interface ISimulationTableRowButtonsProps {
	rowData: GetSimulationsQuery["simulations"][number];
	comparisonSimulations: Array<string>;
	simulatorProductInputEnabled: boolean;
	currentUserOwnerSimulations: Array<{
		simulationId: string;
		role: SimulatorUserRole;
	}>;
	isHovering: boolean;
}

export const SimulationTableRowButtons = (props: ISimulationTableRowButtonsProps) => {
	const { rowData, comparisonSimulations, currentUserOwnerSimulations, isHovering } = props;
	const { t } = useTranslation();
	const { push } = useHistory();

	const [updateSimulations] = useModelsMutation(UPDATE_COMPARISON_SIMULATIONS, {
		refetchQueries: ["GetComparisonSimulations"],
	});

	const isBlueprintNotPublishedOrNoInputEnabled =
		(rowData.blueprint && rowData.blueprint.status !== ProductBlueprintStatus.Published) ||
		(!props.simulatorProductInputEnabled && rowData.blueprint === null);
	const { hasUnassignedBlueprint } = rowData;

	const handleOnDelete = (simulationId: string) => {
		if (comparisonSimulations.includes(simulationId)) {
			const newComparisonArray = comparisonSimulations.filter((simulation) => simulation !== simulationId);
			updateSimulations({ variables: { req: JSON.stringify(newComparisonArray) } });
		}
	};

	const copySimulation = (e: any, simulationId: string) => {
		e.stopPropagation();
		push(`/simulator/copy/${simulationId}`);
	};

	const getDisabledTooltip = () => {
		if (isBlueprintNotPublishedOrNoInputEnabled) {
			return t("simulation-copy-disabled-templates");
		}

		if (hasUnassignedBlueprint) {
			return t("simulator-blueprint-unassigned-domain-copy-simulation");
		}

		return t("simulation-copy");
	};

	const isCopyDisabled = hasUnassignedBlueprint || isBlueprintNotPublishedOrNoInputEnabled;
	
	return (
		<Box display="flex" justifyContent="end" flexWrap="nowrap">
			{isHovering && (
				<>
					<LyfeTooltip title={getDisabledTooltip()}>
						<IconButton
							disabled={isCopyDisabled}
							style={{ pointerEvents: "all" }}
							onClick={(e) => copySimulation(e, rowData?.id)}
						>
							<FileCopyOutlinedIcon fontSize="small" color={isCopyDisabled ? "disabled" : "primary"} />
						</IconButton>
					</LyfeTooltip>
					{currentUserOwnerSimulations?.find((simulation) => simulation.simulationId === rowData.id) ? (
						<DeleteSimulationDialog simulationId={rowData.id as string} deleteTrigger={handleOnDelete} />
					) : (
						<LyfeTooltip title={t("simulator-insufficient-role-delete-hover")}>
							<IconButton>
								<DeleteOutlinedIcon color="disabled" />
							</IconButton>
						</LyfeTooltip>
					)}
				</>
			)}
			<ComparisonIconButton simulationId={rowData.id} isSimulationComplete={rowData.isSimulationComplete} />
		</Box>
	);
};
